import { Button } from "@/components/ui/button";
import { Buildings } from "@phosphor-icons/react";

export function BusinessListCard({ businesses, activeBusiness, workspace, newBizName, onNewBizNameChange, newBizIndustry, onNewBizIndustryChange, onCreateBusiness, creatingBiz }) {
  const canManage = workspace.your_role === "owner" || workspace.your_role === "admin";

  return (
    <div className="bg-[var(--bg-card)] border border-[var(--border)] rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="font-['Cormorant_Garamond'] text-lg font-semibold text-[var(--text-primary)]">Businesses ({businesses.length})</h2>
          <p className="text-xs text-[var(--text-muted)] mt-0.5">Each business has its own brand voice, templates, and content.</p>
        </div>
      </div>

      <div className="space-y-2 mb-4">
        {businesses.map((b) => (
          <div key={b.business_id} className={`flex items-center gap-3 px-3 py-3 rounded-lg border transition-colors ${
            activeBusiness?.business_id === b.business_id
              ? "bg-[var(--accent-subtle)] border-[#FF4400]/30"
              : "bg-[var(--bg-base)] border-[var(--border)]"
          }`} data-testid={`business-row-${b.business_id}`}>
            <Buildings size={18} weight={activeBusiness?.business_id === b.business_id ? "fill" : "regular"}
              className={activeBusiness?.business_id === b.business_id ? "text-[#FF4400]" : "text-[var(--text-muted)]"} />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-[var(--text-primary)] truncate">{b.name}</p>
              {b.industry && <p className="text-xs text-[var(--text-muted)]">{b.industry}</p>}
            </div>
            {activeBusiness?.business_id === b.business_id && (
              <span className="text-[10px] font-['JetBrains_Mono'] uppercase tracking-wider text-[#FF4400] px-2 py-0.5 rounded-full bg-[#FF4400]/10">Active</span>
            )}
          </div>
        ))}
      </div>

      {canManage && (
        <div className="pt-4 border-t border-[var(--border)]">
          <p className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[var(--text-muted)] mb-3">Add Business</p>
          <div className="flex flex-col sm:flex-row gap-2">
            <input className="flex-1 bg-[var(--bg-base)] border border-[var(--border-strong)] rounded-lg px-3 py-2 text-sm text-[var(--text-primary)] placeholder:text-[var(--text-muted)] focus:outline-none focus:ring-1 focus:ring-[#FF4400]"
              value={newBizName} onChange={(e) => onNewBizNameChange(e.target.value)} placeholder="Business name" data-testid="new-biz-name" />
            <input className="sm:w-40 bg-[var(--bg-base)] border border-[var(--border-strong)] rounded-lg px-3 py-2 text-sm text-[var(--text-primary)] placeholder:text-[var(--text-muted)] focus:outline-none focus:ring-1 focus:ring-[#FF4400]"
              value={newBizIndustry} onChange={(e) => onNewBizIndustryChange(e.target.value)} placeholder="Industry" data-testid="new-biz-industry" />
            <Button onClick={onCreateBusiness} disabled={!newBizName.trim() || creatingBiz}
              className="bg-[#FF4400] hover:bg-[#FF6633] text-white gap-2" data-testid="create-business-btn">
              <Buildings size={16} weight="bold" />
              {creatingBiz ? "Creating..." : "Create"}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
